// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__V-jSR","formControl":"addForm_formControl__R17RM","list":"addForm_list__gHyaQ","btnWrpper":"addForm_btnWrpper__zzD3o"};